import React from 'react';
import { login } from '../../util/axios_utils';
import './Login.css';
import { Link } from 'react-router-dom';
import { ACCESS_TOKEN, DEVICE_ID } from '../../constants';
import { Input, Button, notification, Form, Space, Typography } from 'antd';
import { UserOutlined, LockOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import LoadingIndicator from '../../common/LoadingIndicator';
import UnderConstruction from '../../common/UnderConstruction';
const FormItem = Form.Item;



const Login = (props) => {
    const {
        onLogin,
        isLoading, underConstruction
    } = props;

    const handleSubmit = async (values) => {
        const loginRequest = Object.assign({}, values);
        localStorage.setItem(DEVICE_ID, uuidv4());
        const DeviceInfo = {
            deviceId: localStorage.getItem(DEVICE_ID),
            deviceType: "DEVICE_TYPE_ANDROID",
            notificationToken: "N1"
        }
        loginRequest.deviceInfo = DeviceInfo;

        await login(loginRequest)
            .then(response => {
                localStorage.setItem(ACCESS_TOKEN, response.accessToken);
                onLogin();
            }).catch(error => {
                        console.log(error);
                if (error.data.data) {
                    notification.error({
                        message: 'Портал ЖКХ',
                        description: error.data.data
                    });
                } else {
                    notification.error({
                        message: 'Портал ЖКХ',
                        description: 'Извините, в настоящий момент сервис не доступен. Попробуйте позднее'
                    });
                }
            });
    }

    if (isLoading) {
        return <LoadingIndicator />;
    }
    if (underConstruction) {
        return <UnderConstruction />;
    }
    return (
        <div className="login-container">
            <Form onFinish={handleSubmit} className="login-form">
                <Typography className="page-title">Вход в личный кабинет</Typography>
                <FormItem name="email" rules={[{ required: true, message: "Пожалуйста, введите Ваш логин!" }]}>
                    <Input className="email"
                        prefix={<UserOutlined />}
                        size="large"
                        name="usernameOrEmail"
                        placeholder="Логин" />
                </FormItem>
                <FormItem name="password" rules={[{ required: true, message: "Пожалуйста, введите Ваш пароль!" }]}>
                    <Input.Password
                        prefix={<LockOutlined />}
                        size="large"
                        name="password"
                        type="password"
                        placeholder="Пароль"
                        iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                    />
                </FormItem>
                <FormItem>
                    <Button type="primary" htmlType="submit" size="large" className="login-form-button button">Войти</Button>
                    <Space>
                        <Link to="/signup">Зарегистрироваться!</Link>  <Link to="/forgotpassword">Забыли пароль?</Link>
                    </Space>
                </FormItem>

            </Form>
        </div>
    );

}


export default Login;